import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';

const typographyStyles = {
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '19.92px',
  letterSpacing: '0.4px',
  color: '#9E9E9E'
};

const TimestampFooter = ({ timestamp }) => (
  <Box sx={{ mt: 1 }}>
    <Typography sx={typographyStyles}>Sent {timestamp}</Typography>
  </Box>
);

TimestampFooter.propTypes = {
  timestamp: PropTypes.string.isRequired
};

export default TimestampFooter;
